import { createModelSegment } from 'client/data/luckdragon/segment';
import { EdmundsAPI } from 'client/data/api/api-client';
import { DealerInfoModel, getDealerInfoNamePath } from 'client/data/models/dealer-info';
import { withMetrics } from 'client/data/api/api-metrics';
import { getM2ForSaleUrl } from 'site-modules/shared/utils/inventory/get-m2-for-sale-url';

function getDealerInventoryModel(model) {
  const thumbnailUrl = getM2ForSaleUrl(model.thumbnailUrl);

  return thumbnailUrl === model.thumbnailUrl
    ? model
    : {
        ...model,
        thumbnailUrl,
      };
}

function getDealerInventory(response) {
  return response.json().then(responseJson => {
    const dealerInventory = responseJson.response;

    if (!dealerInventory) {
      return null;
    }

    if (!dealerInventory.models) {
      return dealerInventory;
    }

    const models = dealerInventory.models.map(getDealerInventoryModel);

    return models.every((model, index) => model === dealerInventory.models[index])
      ? dealerInventory
      : {
          ...dealerInventory,
          models,
        };
  });
}

function getDealerInventoryById(id, context) {
  const dealerInventoryUrl = `/inventory/v5/rooftop/${id}/inventoriescount`;
  return withMetrics(EdmundsAPI, context).fetch(dealerInventoryUrl).then(getDealerInventory);
}

export const DealerInventoryModel = createModelSegment('dealerInventory', [
  {
    path: 'dealerInventory.id.{dealerId}',
    resolve(match, context) {
      return getDealerInventoryById(match.dealerId, context);
    },
  },
  {
    path: 'dealerInventory.name.{logicalName}',
    resolve(match, context) {
      return context.resolveValue(getDealerInfoNamePath(match.logicalName), DealerInfoModel).then(dealerInfo => {
        if (!dealerInfo) return null;
        const { id } = dealerInfo;
        return getDealerInventoryById(id, context);
      });
    },
  },
]);
